import styled from "styled-components";

export const RandomArtStyled = styled.div`
  width: 100%;
  padding-bottom: 4rem;
`;
